import styled from 'styled-components';
import {Image} from '@volkswagen-onehub/components-core';

export const CardInfoContainerLayer = styled.div<{
  gap: string;
  absolute?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap};
  height: 100%;
  padding: 24px;
  will-change: opacity;

  @media (min-width: 960px) {
    padding: 22px;
  }

  @media (min-width: 1600px) {
    padding: var(--size-dynamic0100);
  }

  ${({absolute}) =>
    absolute &&
    `
    position: absolute;
    inset: 0;
  `}
`;

export const CardImageContainer = styled.div`
  height: 100%;
  border: 2px solid #ffffff;
  position: relative;
  overflow: hidden;
`;

export const CardImage = styled(Image)`
  object-fit: cover;
  height: 100%;
`;
